@if (resposta.has_answer && resposta.is_participating) {
    <div class="card-footer">
        <span class="section">
            <span class="information-span">
                <i class="fa fa-info-circle"></i>
                <div>
                    <span>
                        <b>
                            {{respostaRodapeTipoPagamento}}
                            @if (respostaRodapeTipoPagamentoTooltip) {
                                <i class="fa fa-exclamation-circle text-warning" [tooltip]="respostaRodapeTipoPagamentoTooltip"></i>
                            }
                        </b>
                    </span>
                </div>
            </span>
            @if ((userService.userHasCashback() && resposta.cashback_potencial > 0) || resposta.rebate_potencial > 0) {
                <span class="text-success cashback-span">
                    <i class="fa fa-usd"></i>
                    @if (userService.userHasCashback() && resposta.has_cashback) {
                        <b> {{'buyer.cotacao.area-respostas.resposta.rodape.cashback.customizado' | translate}} </b>
                    }
                    @if ((!userService.userHasCashback() || !resposta.has_cashback) && resposta.rebate_potencial > 0) {
                        <b> {{'buyer.cotacao.area-respostas.resposta.rodape.cashback.padronizado' | translate: {value: (resposta.rebate_potencial| currency: "R$")} }} </b>
                    }
                </span>
            }
        </span>
        <span class="section valores">
            <div class="final-price">
                <span>{{ 'buyer.cotacao.area-respostas.resposta.rodape.total-cia' | translate }}:</span>
                @if (respostaRodapeTotalCia > 0) {
                    <span>{{ (respostaRodapeTotalCia) | currency:'R$'}}</span>
                } @else {
                    <span>{{ 'buyer.cotacao.area-respostas.resposta.rodape.sem-info' | translate }}</span>
                }
            </div>
            <ul class="price-informations">
                <span class="base-infos">
                    <li>
                        <span>{{ 'buyer.cotacao.area-respostas.resposta.rodape.total-pecas' | translate }}{{resposta.is_chosen ? ' (' + resposta.total_itens_selecionados + ')' : ''}}:</span>
                        <span>{{ respostaRodapePecasValor | currency:'R$' }}</span>
                    </li>
                    <li>
                        <span>
                            {{ 'buyer.cotacao.area-respostas.resposta.rodape.frete.label' | translate }}:
                            @if (resposta.done_configuration && resposta.shipping && resposta.shipping.length > 0 && resposta.shipping[0].shipping_cost > 0) {
                                <i class="fa fa-exclamation-circle text-warning"
                                    [ngbTooltip]="shipping_information" tooltipClass="information-tooltip-window"
                                    placement="top" [openDelay]="500"></i>
                            }
                        </span>
                        <span>{{ respostaRodapeFrete }}</span>
                        <ng-template #shipping_information>
                            <div class="information-tooltip position">
                                <div>
                                    <i-feather name="truck"></i-feather>
                                </div>
                                <b>{{ 'buyer.cotacao.area-respostas.resposta.rodape.frete.tooltip.titulo' | translate }}</b>
                                <ul>
                                    <li>{{ 'buyer.cotacao.area-respostas.resposta.rodape.frete.tooltip.valor-regiao' | translate: {value: resposta.shipping[0].shipping_cost | currency:'R$'} }}</li>
                                    <li>{{ 'buyer.cotacao.area-respostas.resposta.rodape.frete.tooltip.frete-gratis' | translate: {value: resposta.shipping[0].min_value | currency:'R$'} }}</li>
                                </ul>
                            </div>
                        </ng-template>
                    </li>
                </span>
                <li class="final-price">
                    <span>{{ 'buyer.cotacao.area-respostas.resposta.rodape.total' | translate }}:</span>
                    <span>{{ (respostaRodapeTotal) | currency:'R$'}}</span>
                </li>
            </ul>
        </span>
    </div>
}
